import React, { Component } from 'react';

import './ConditionEdit.css';

class ConditionEdit extends Component {

  static defaultProps = {
    conditionText : "UNDEFINED",
    editConfirm : () => {

    }
  }

  state = {
    editedConditionText : "UNDEFINED",
  }

  constructor(props){
    super(props);
    this.state = {
      editedConditionText : props.conditionText,
    }
  }

  /**
   * 유저가 수정했을 시 핸들러
   */
  handleOnConfirm = (conditionText) => {
    this.props.onConfirm(conditionText);
  }

  /**
   * 수정버튼 핸들러
   */
  handleClickOnConfirmBtn = (e) => {
    this.props.editConfirm(this.state.editedConditionText);
  }

  /**
   * 취소버튼 핸들러
   */
  handleClickOnCancelBtn = (e) => {                                      
    this.props.setIsEditMode(false);
  }

  /**
   * 컨디션 텍스트 Input onChange 핸들러
   */
  handleOnChangeCondidtionText = (e) => {
    this.setState({
      editedConditionText : e.target.value,
    })
  }
  
  render() { 
    return (
      <React.Fragment>
        <div className="condition-text edit">
          <input className="condition-input" 
            value={this.state.editedConditionText}
            onChange={this.handleOnChangeCondidtionText} />
        </div>
        {/* <div className='btn-area edit'> */}
          <button className="btn btn-primary edit-confirm-btn"
            onClick={this.handleClickOnConfirmBtn} >
            수정
          </button>
          <button className="btn btn-danger edit-cancel-btn"
            onClick={this.handleClickOnCancelBtn} >
            취소
          </button>
        {/* </div> */}
      </React.Fragment>
    );
  }
}
 
export default ConditionEdit;